import React from "react";
// import { StaticImage } from "gatsby-plugin-image";
import FigureCover from "../FigureCover";

import template1Graphique2 from "../../images/template2-graphique.svg";

const PC2 = ({ input }) => (
  <div className='template2'>
    <div
      className='grid h-screen'
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "10px",
        gridTemplateAreas: `
        'group1 group2'
        `
      }}>
      <div style={{ gridArea: "group1", paddingTop: "35px" }}>
        <div className='flex flex-col h-full'>
          <div className='mb-lg'>
            <img
              src={template1Graphique2}
              alt='template2 graphique'
              className='w-full'
            />
          </div>
          <div className='image1 filter grayscale' style={{ flex: 1 }}>
            {input[0] && <FigureCover input={input[0]} />}
          </div>
        </div>
      </div>

      <div className='image2 filter grayscale' style={{ gridArea: "group2" }}>
        {input[1] && <FigureCover input={input[1]} />}
      </div>
    </div>
  </div>
);

export default PC2;
